import { BackgroundProcessor, BackgroundProcessorOptions } from './BackgroundProcessor';
/**
 * Options passed to [[SolidColorBackgroundProcessor]] constructor.
 */
export interface SolidColorBackgroundProcessorOptions extends BackgroundProcessorOptions {
   color: string
}

export class SolidColorBackgroundProcessor extends BackgroundProcessor {

  private _color = '#000000'
  private readonly _name: string = 'SolidColorBackgroundProcessor';

  constructor(options: SolidColorBackgroundProcessorOptions) {
    super(options)
    this._color = options.color
  }

  protected _setBackground(inputFrame: OffscreenCanvas): void {
    this._outputContext.fillStyle = this._color
    this._outputContext.fillRect(0, 0, inputFrame.width, inputFrame.height);

  }
}
